export enum Units {
    MM = 'mm',
    INCH = 'inch',
    BOTH = 'both'
}
